<template>
  <div class="user-details-container">
    <img
      v-if="profilePictureUrl"
      alt="profile picture"
      class="user-profile-picture"
      :src="profilePictureUrl" />
    <div class="user-email">{{ getValueOrDash(email) }}</div>
  </div>
</template>

<script setup lang="ts">
  import { computed, Ref, ref, watch } from 'vue';

  import { UserOrganization } from '@/common/models';
  import { getValueOrDash } from '@/globals';
  import UsersService from '@/org-app/components/users/UsersService';

  interface ICreatedByCellProps {
    userID: number;
  }

  const props = defineProps<ICreatedByCellProps>();

  const userID: Ref<number> = ref(props.userID);
  const user: Ref<UserOrganization> = ref();

  const email = computed(() => user.value?.email);
  const profilePictureUrl = computed(() => user.value?.user.profilePictureUrl);

  async function updateUser() {
    user.value = await UsersService.fetchUser(userID.value);
  }

  watch(userID, updateUser, { immediate: true });
</script>

<style scoped>
  .user-details-container {
    display: flex;
    flex-direction: row;
    gap: 10px;
    align-items: center;
  }

  .user-profile-picture {
    width: 25px;
    height: 25px;
    border-radius: 50%;
    object-fit: cover;
  }
</style>
